import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Formik } from 'formik';

import { SingleSelect } from '@/common';
import { FilterModalLayout, FilterPopUpValues } from '@/components/layouts';
import { PAGE_SIZE } from '@/constants';
import { useGetAllDevices } from '@/services';
import { DeviceBasic, FilterScreensProps, SelectOptionProps } from '@/types';

export const FilterScreens = ({ onClose, filterByDevice, apply, reset }: FilterScreensProps) => {
  const [t] = useTranslation('common');

  const [searchDevice, setSearchDevice] = useState<string>('');
  const {
    data: allDevices,
    fetchNextPage,
    hasNextPage
  } = useGetAllDevices(PAGE_SIZE, searchDevice);

  const getDeviceOptions = () => {
    return allDevices?.pages.flatMap((page) =>
      page.data?.items.map((device: DeviceBasic) => ({
        value: device.id,
        label: device.name
      }))
    ) as SelectOptionProps[];
  };

  return (
    <Formik
      initialValues={{
        filterByDevice: filterByDevice ?? null
      }}
      onSubmit={() => undefined}>
      {({ setFieldValue, values }) => (
        <Form>
          <FilterModalLayout
            apply={apply as (values: FilterPopUpValues) => void}
            reset={reset}
            onClose={onClose}
            values={values}
            mode='dropdown'>
            <SingleSelect
              placeholder={t('selectDevice')}
              isClearable
              label={t('device')}
              id='filterByDevice'
              options={getDeviceOptions()}
              handleChange={(value) => setFieldValue('filterByDevice', value as SelectOptionProps)}
              value={values.filterByDevice}
              fetchNextPage={fetchNextPage}
              hasNextPage={hasNextPage}
              isSearchable={true}
              handleInputChange={(inputValue: string) => setSearchDevice(inputValue)}
            />
          </FilterModalLayout>
        </Form>
      )}
    </Formik>
  );
};
